import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToHash = (smooth = true): void => {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    // Function to handle scrolling
    const scrollToElement = () => {
      // If there's a hash in the URL
      if (hash) {
        // Small delay to ensure the DOM is fully ready
        setTimeout(() => {
          const element = document.querySelector(hash);
          
          if (element) {
            // Using scrollIntoView with smooth behavior for better UX
            element.scrollIntoView({
              behavior: smooth ? 'smooth' : 'auto',
              block: 'start',
            });
          }
        }, 100);
      } else {
        // If no hash, scroll to top of the page when route changes
        window.scrollTo({
          top: 0,
          behavior: smooth ? 'smooth' : 'auto',
        });
      }
    };

    scrollToElement();
  }, [hash, pathname, smooth]); // Re-run when hash or pathname changes
};